"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCompetitorApi = addCompetitorApi;
exports.deleteCompetitorApi = deleteCompetitorApi;
exports.editCompetitorApi = editCompetitorApi;
exports.editCompetitorAssociateApi = editCompetitorAssociateApi;
exports.getCompetitorConfigApi = getCompetitorConfigApi;
exports.getCompetitorListApi = getCompetitorListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// 价格 - 价格监测 - 商品竞品配置

/**
 * 获取商品竞品配置列表
 * @param params 查询参数
 */
function getCompetitorListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/competitor/list',
    method: 'get',
    params: params
  });
}

/**
 * 获取监控商品竞品配置信息
 * @param params 查询参数
 */
function getCompetitorConfigApi(params) {
  return (0, _request.default)({
    url: "/admin/platform/competitor/config/".concat(params.productId, "/").concat(params.skuId),
    method: 'get',
    params: {
      platform: params.platform
    }
  });
}

/**
 * 手动-新增竞品
 * @param data 提交数据
 */
function addCompetitorApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/competitor/add',
    method: 'post',
    data: data
  });
}

/**
 * 手动-编辑竞品
 * @param id 竞品ID
 */
function editCompetitorApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/competitor/edit/".concat(data.id),
    method: 'put',
    data: data
  });
}

/**
 * 修改关联状态
 * @param id 竞品ID
 */
function editCompetitorAssociateApi(data) {
  return (0, _request.default)({
    url: "/admin/platform/competitor/associate/".concat(data.id, "?isAssociated=").concat(data.isAssociated),
    method: 'put'
  });
}

/**
 * 删除竞品
 * @param id 竞品ID
 */
function deleteCompetitorApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/competitor/delete/".concat(id),
    method: 'delete'
  });
}